import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

const queryTheme = new URLSearchParams(location.search).get("theme");
const saved = queryTheme ?? localStorage.getItem("northline-theme");
if (saved === "dark" || saved === "sepia") document.documentElement.classList.add(saved);

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
